export default "/images/ed8a066115ffc1589bab6bf4b7eed260.avif";